<template>
  <div class="payment">
    <div class="payment__header flex flex--align-center flex--justify-between">
      <v-item-title title="支付管理"></v-item-title>
      <Button class="payment__save-btn"
              type="primary"
              :disabled="!this.billingUpdateList.length && !this.balanceUpdateList.length"
              @click="updateJournal"
              shape="circle">保存</Button>
    </div>
    <Payment-Component
      :balance-flag-list="balanceFlagList"
      :billing-flag-list="billingFlagList"
      editable
      @on-update-item="handleUpdateItem"
    ></Payment-Component>
  </div>
</template>

<script>
import { updateJournal, updateBilling } from '@/api/settlement/payment';
import bus from '@/utils/bus';
import PaymentComponent from '@/components/b-components/payment/paymentComponent.vue';

export default {
  name: 'payment',
  components: {
    PaymentComponent,
  },
  data() {
    return {
      balanceUpdateList: [],
      balanceFlagList: [],
      billingUpdateList: [],
      billingFlagList: [],
    };
  },
  methods: {
    handleUpdateItem(item, isChanged, type) {
      console.log(item, isChanged, type);
      const index = this[`${type}UpdateList`].findIndex((u) => u.id === item.id);
      if (isChanged) {
        if (index > -1) {
          this[`${type}UpdateList`].splice(index, 1, item);
        } else {
          this[`${type}UpdateList`].push(item);
        }
      } else if (index > -1) {
        this[`${type}UpdateList`].splice(index, 1);
      }
    },
    async updateJournal() {
      const requestList = [];
      if (this.balanceUpdateList.length) {
        requestList.push(updateJournal(this.balanceUpdateList.map((item) => ({
          id: item.id,
          journal_status: item.journal_status,
        }))));
      }
      if (this.billingUpdateList.length) {
        requestList.push(updateBilling(this.billingUpdateList.map((item) => ({
          id: item.id,
          billing_status: item.billing_status,
        }))));
      }
      if (requestList.length) {
        const res = await Promise.all(requestList);
        let isSuccess = false;
        if (res && res.length) {
          isSuccess = res.every((item) => !!item);
          if (isSuccess) {
            this.$Message.success('操作成功');
            if (this.balanceUpdateList.length) {
              [this.balanceFlagList] = res;
              if (this.billingUpdateList.length) {
                [, this.billingFlagList] = res;
              }
            } else {
              [this.billingFlagList] = res;
            }
            this.billingUpdateList = [];
            this.balanceUpdateList = [];
          }
        }
        return isSuccess;
      }
      return false;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.billingUpdateList.length || this.balanceUpdateList.length) {
      this.$Modal.confirm({
        title: '<span class="v-icon icon iconfont iconerror-24px1"></span><span class="title-text">操作未保存</span>',
        content: '支付管理内容未保存！请保存后再继续其他操作。',
        width: 448,
        okText: '保存',
        cancelText: '忽略',
        loading: true,
        onOk: async () => {
          const res = await this.updateJournal();
          this.$Modal.remove();
          if (res) {
            next();
          } else {
            bus.$emit('updateActiveName');
            next(false);
          }
        },
        onCancel() {
          next();
        },
      });
    } else {
      next();
    }
  },
};
</script>

<style lang="less">
  .payment{
    height: 100%;
    padding-top: 16px;
    position: relative;
    &__save-btn{
      font-weight: 500;
      padding: 0;
      width: 110px;
      height: 36px;
      &[disabled] {
        background-color: rgba(0, 0, 0, 0.12);
        color: rgba(0, 0, 0, 0.26);
        border: none;
        &:hover{
          background-color: rgba(0, 0, 0, 0.12);
          color: rgba(0, 0, 0, 0.26);
        }
      }
    }
    &__header{
      padding: 0 16px;
      margin-bottom: 24px;
    }
  }
</style>
